import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useToast } from "../../hook/usetoast";
import { getProvider } from "../../web3/getProvider";
import Web3 from "web3";

import cashFlowAbi from "../../contract/cashFlow.json";
import usdtAbi from "../../contract/usdtAbi.json";
import { useUserWithdraw, useWithdrawMinMax } from "./api/api";
import { contractAddress } from "../../contract/contractAddress";
import { NumericFormat } from "react-number-format";
import { useModalContext } from "../../contexts/ModalContext";
import Loader from "../Loader/buttonLoad";
import { useAppKitAccount } from "@reown/appkit-controllers/react";
import { useProfileDetails } from "../profile-details/api/profileapi";
import { withdrawEncrypt } from "../../hook/encrypt";
import { useNavigate } from "react-router-dom";
const WithdrawModal = ({ modalOpen, balance, modalClose }) => {
  const { isloadingconnect, setIsloadingconnect } = useModalContext();
  const { address } = useAppKitAccount();
  const [cooldownUntil, setCooldownUntil] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const navigate=useNavigate()
  const { data: profile, refetch } = useProfileDetails();

  const toast = useToast();
  const [value, setValue] = useState("");

  const [fee, setFee] = useState();

  const [errorMessage, setErrorMessage] = useState();
  const [receiveUsdt, setReceiveUsdt] = useState(0);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const getCooldownKey = (addr) => `withdrawdown_${addr?.toLowerCase()}`;

  const provider = getProvider();
  const web3 = new Web3(provider);

  const withDrawOut = useUserWithdraw();
  const { data: withdrawMinMax } = useWithdrawMinMax();

  const withdrawContract = new web3.eth.Contract(
    cashFlowAbi,
    contractAddress?.withdrawCashFlow,
  );
  useEffect(() => {
    if (!address) return;

    const stored = localStorage.getItem(getCooldownKey(address));

    if (stored && Date.now() < stored) {
      setCooldownUntil(parseInt(stored));
    } else {
      setCooldownUntil(null);
    }
  }, [address]);
  useEffect(() => {
    if (!cooldownUntil || !address) return;

    const interval = setInterval(() => {
      const diff = cooldownUntil - Date.now();

      if (diff <= 0) {
        setCooldownUntil(null);
        setRemainingTime(0);
        localStorage.removeItem(getCooldownKey(address));
        clearInterval(interval);
      } else {
        setRemainingTime(Math.floor(diff / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [cooldownUntil, address]);

  const isCooldownActive = cooldownUntil !== null;

  useEffect(() => {
    withDrawFee();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fee,modalOpen]);
  const withDrawFee = async () => {
    try {
      setIsloadingconnect(true)
      const fee = await withdrawContract.methods.adminFee().call();
      const feeInWei = web3.utils.fromWei(fee, "ether");
      setFee(feeInWei);
    } catch {
      setIsloadingconnect(false)
    }finally{
      setIsloadingconnect(false)
    }
  };


  const userWithDraw = async () => {
    setIsloadingconnect(true);
    const randomData = withdrawEncrypt(`${"WITHDRAW"}${profile.userId}`);

    const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
    const usdtUserBalance = await usdtContract.methods
      .balanceOf(contractAddress?.withdrawCashFlow)
      .call();
    const usdtTotalBalance = web3.utils.fromWei(usdtUserBalance, "ether");

    if (Number(value) > usdtTotalBalance) {
      setIsloadingconnect(false);
      toast.error("Transfer amount exceeds balance");
      return;
    }

    try {
      const fiveMin = Date.now() + 3 * 60 * 1000;
      setCooldownUntil(fiveMin);
      localStorage.setItem(getCooldownKey(address), fiveMin);
      const res = await withDrawOut.mutateAsync({
        amount: value,
        randomID: randomData,
      });
      if (res?.status) {
        close();
        await refetch();
         navigate("/withdraw-history")
      } else {
        await refetch();
      }
    } catch (error) {
      await refetch();
      
      setIsloadingconnect(false);
      if (
        error.message.includes(
          "MetaMask Tx Signature: User denied transaction signature.",
        )
      ) {
        toast.error("Transaction rejected by user.");
      }
    } finally {
      setIsloadingconnect(false);
    }
  };

  const handleValueChange = async (e) => {
    const value = e.target.value;
    setValue(value);
    const isValid = value > 0 && !isNaN(value);

    if (value > balance) {
      setErrorMessage("Insufficient USDT balance");
    } else {
      setErrorMessage("");
    }
    let netWorkfee = value - withdrawMinMax?.data?.feeUsdt;
    let feeAmount = (netWorkfee * fee) / 100;
    let receiveAmount = netWorkfee - feeAmount;
    setReceiveUsdt(receiveAmount);
    setButtonEnabled(isValid);
  };
  const close = async () => {
    modalClose();
    setValue("");
    setReceiveUsdt("");
  };

  const closeBtn = (
    <button className="close" onClick={close}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3359 10.5L16.5547 14.7188C16.7891 14.9531 16.7891 15.3828 16.5547 15.6172L15.5781 16.5938C15.3438 16.8281 14.9141 16.8281 14.6797 16.5938L10.5 12.375L6.28125 16.5938C6.04688 16.8281 5.61719 16.8281 5.38281 16.5938L4.40625 15.6172C4.17188 15.3828 4.17188 14.9531 4.40625 14.7188L8.625 10.5L4.40625 6.32031C4.17188 6.08594 4.17188 5.65625 4.40625 5.42188L5.38281 4.44531C5.61719 4.21094 6.04688 4.21094 6.28125 4.44531L10.5 8.66406L14.6797 4.44531C14.9141 4.21094 15.3438 4.21094 15.5781 4.44531L16.5547 5.42188C16.7891 5.65625 16.7891 6.08594 16.5547 6.32031L12.3359 10.5Z"
          fill="#6E737E"
        />
      </svg>
    </button>
  );

  return (
    <>
      {isloadingconnect && <Loader />}

      <Modal
        isOpen={modalOpen}
        centered="true"
        className="mymodal"
        backdropClassName="modalbackbg"
      >
        <ModalHeader close={closeBtn}>Withdraw</ModalHeader>
        <ModalBody>
          <>
            <div className="form-group formInputs">
              <label htmlFor="amount">Amount</label>
              <div className="input-group">
                <NumericFormat
                  value={value}
                  className="form-control"
                  placeholder="0.00"
                  allowNegative={false}
                  onChange={handleValueChange}
                />
                <div className="input-group-append">
                  <div
                    className="input-group-text border-left rounded-0 text-white"
                    style={{ borderColor: "rgba(255,255,255,0.1) !important" }}
                  >
                    USDT
                  </div>
                </div>
              </div>
              {errorMessage && (
                <div className="text-danger mt-2">{errorMessage}</div>
              )}
            </div>
            <div className="fs-14 fw-400 mb-3">
              Balance{" "}
              <span className="text-primary">
                {parseFloat(balance).toFixed(3)} USDT
              </span>
            </div>
            <div className="row justify-content-center">
              <div className="col-sm-8">
                <div className="darkborderBx">
                  <div className="d-flex justify-content-between">
                    <span className="text-white-60">Fee</span>
                    <span>{fee}%</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-white-60">Network Fee</span>
                    <span>{withdrawMinMax?.data?.feeUsdt} USDT</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-white-60">Min</span>
                    <span>{withdrawMinMax?.data?.min} USDT</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-white-60">Max</span>
                    <span>{withdrawMinMax?.data?.max} USDT</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-white-60">Received Amount</span>
                    <span>
                       {receiveUsdt
                        ? parseFloat(receiveUsdt)
                            .toFixed(4)
                            .replace(/(\.\d*?[1-9])0+$/, "$1")
                            .replace(/\.0+$/, "")
                        : 0}{" "}
                      USDT
                    </span>
                  </div>
                  <div className="">
                    <span className="text-white-60"></span>
                    {isCooldownActive && (
                      <span style={{ color: "red" }}>
                        Try again in {Math.floor(remainingTime / 60)} min{" "}
                        {remainingTime % 60} sec
                      </span>
                    )}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <div className="mt-4 mb-3">
                <button
                  className="btn btn-primary fs-18 fw-600 px-4 px-lg-5"
                  onClick={userWithDraw}
                  disabled={
                    value === "" ||
                    value === "0" ||
                    !buttonEnabled ||
                    errorMessage === "Insufficient USDT balance" ||
                    value < withdrawMinMax?.data?.min ||
                    value > withdrawMinMax?.data?.max ||
                    isCooldownActive
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        </ModalBody>
      </Modal>
    </>
  );
};
WithdrawModal.propTypes = {
  modalOpen: PropTypes.any.isRequired,
  modalClose: PropTypes.any.isRequired,
  balance: PropTypes.any.isRequired,
};

export default WithdrawModal;
